import React, { useState } from 'react';
import ChatbotWidget from './ChatbotWidget';
import '../../styles/ChatbotWidget.css';

const FloatingChatButton = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);

    return (
        <>
            <button
                className="floating-chat-btn"
                onClick={() => setIsChatOpen(!isChatOpen)}
                aria-label="Open chat support"
            >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
                    <path d="M21 11.5C21 16.75 16.75 21 11.5 21C6.25 21 2 16.75 2 11.5C2 6.25 6.25 2 11.5 2C16.75 2 21 6.25 21 11.5Z" fill="white" />
                    <circle cx="8" cy="10" r="1.5" fill="#FF6B3D" />
                    <circle cx="15" cy="10" r="1.5" fill="#FF6B3D" />
                    <path d="M7 14C7 14 9 16 12 16C15 16 17 14 17 14" stroke="#FF6B3D" strokeWidth="2" strokeLinecap="round" />
                </svg>
            </button>

            <ChatbotWidget
                isOpen={isChatOpen}
                onClose={() => setIsChatOpen(false)}
            />
        </>
    );
};

export default FloatingChatButton;
